import React from 'react';
import './Icon.scss';
const rootClassName = 'icon-component';

export const ListDotIcon = () => {
  return (
    <svg
      className={rootClassName}
      viewBox='0 0 7 7'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
    >
      <circle cx='3.5' cy='3.5' r='3.5' />
    </svg>
  );
};
